import { fetchAuthSession } from 'aws-amplify/auth';
import config from './config';

export async function getAuthHeaders(): Promise<HeadersInit> {
  const session = await fetchAuthSession({ forceRefresh: true });
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('Not authenticated');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function apiFetch(
  path: string,
  init: RequestInit = {},
): Promise<Response> {
  const headers = await getAuthHeaders();
  return fetch(`${config.BASE_URL}${path}`, {
    ...init,
    headers: {
      ...headers,
      ...(init.headers || {}),
    },
  });
}

/** Public GET (no auth), used by legacy FAQ load. */
export function publicFetch(path: string, init: RequestInit = {}) {
  return fetch(`${config.BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  });
}
